<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addTrackNumberModal"
        persistent
        max-width="340px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              ><span class="headline">{{ $t('customer.addTrackNumberTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click="closeAddTrackNumberModal(), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                :value="checkAlert"
                type="success"
              >
                {{ $t('customer.trackNumberAddedSuccessfully') }}
              </v-alert>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    :label="$t('columns.trackNumber') + '*'"
                    v-model="addTrackNumberData.track_number"
                    :error-messages="errors.collect('Track number')"
                    v-validate="'required'"
                    data-vv-name="Track number"
                    @input="removeSpaces()"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                id="sendButton"
                type="submit"
                style="height:auto" class="rtl-mr-7pct"
                outline
                color="success"
              >{{ $t('common.add') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: [
    'checkAlert',
    'closeAddTrackNumberModal',
    'addTrackNumberModal',
    'addTrackNumberData',
    'addTrackNumber'
  ],

  methods: {
    removeSpaces() {
      this.addTrackNumberData.track_number = this.addTrackNumberData.track_number.replaceAll(/\s+/g, '')
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.addTrackNumber()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addTrackNumber.vue